import React from 'react'
import InputShadow from './../../elements/InputShadow'
import InputShadowOne from './../../elements/InputShadowOne'
import ButtonShadow from './../../elements/ButtonShadow'
// IMAGES
import imageIconTelephone from '../../../images/iconTelephone.png'
import ButtonModalClose from '../../elements/ButtonModalClose'

const ModalInfoClient = ({ values, handleChange, _updateInformationsClient, count, setCount }) => {
    return (
        <div className="modal fade" id="modalInfoClient" >
            <div className="modal-dialog  modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalInfoClient">Informations</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> 
                    </div>

                    <div className="modal-body">

                        <div className='mt-3'> 

                            {/* TITRE */}
                            <div className='text-center'>Informations</div>  

                            {/* SURNAME */}
                            <InputShadow value={values.surname} placeholder="Prénom"  name='surname' onChange={handleChange} /> 

                            {/* NAME */}
                            <InputShadow value={values.name} placeholder="Nom"  name='name' onChange={handleChange} /> 

                            {/* INPUT PHONE */}
                            <InputShadowOne value={values.phone} onChange={handleChange} placeholder='Téléphone' image={imageIconTelephone} name='phone' />

                            {/* BUTTON ENREGISTRER */}
                            <ButtonModalClose
                                onClick={_updateInformationsClient} 
                                title='Enregistrer'
                            />

                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalInfoClient